<template>
  <v-container class="pt-0">
    <v-layout row wrap>
      <v-container class="header-wrapper" fluid>
        <v-row>
          <v-col class="pb-0">
            <div class="title-wrapper">
              <h1 class="page-title">Documents</h1>
            </div>
            <v-btn color="accent" style="float: right;" depressed dark @click="downloadZip">
              <v-progress-circular indeterminate
                                   color="white" size="20" width="2" v-if="downloading">
              </v-progress-circular>
              Download {{selected.length}}
            </v-btn>
            <v-btn color="accent" style="float: right; marginRight:10px" outlined dark :to="'/documents-archived'">Archived</v-btn>
          </v-col>
        </v-row>
        <v-expansion-panels v-model="filterPanel"
                            :disabled="disabled">
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="none"></v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col lg="3" md="3" sm="12" cols="12" class="filter-wrapper">
                  <v-row>
                    <v-col lg="12" md="12" sm="12" cols="12">
                      <v-text-field v-model="general"
                                    outlined
                                    clearable
                                    :hint="!searchEmpty ?  '' : ('Searching:' )"
                                    persistent-hint
                                    label="Search filename or WO#">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col xl ="8" lg="8" md="8" sm="12" cols="12" class="filter-wrapper">
                  <v-row>
                  <v-col xl="3" lg="3" md="6" sm="6" cols="6">
                    <v-autocomplete v-model="category"
                                    :items="categoryList"
                                    outlined
                                    flat
                                    multiple
                                    clearable
                                    :hint ="category.toString()"
                                    persistent-hint
                                    label="Category">
                      <template v-slot:selection="{ index, item }">
                        <span v-if="index < 1"
                                dark
                                label
                                small>
                          {{ item }}
                        </span>
                        <span v-else-if="index === 1"
                              class="overline grey--text text--darken-3 mx-2">
                          +{{ category.length - 1 }}
                        </span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col xl="3" lg="3" md="6" sm="6" cols="6">
                    <v-autocomplete v-model="type"
                                    :items="typeList"
                                    outlined
                                    flat
                                    multiple
                                    clearable
                                    :hint ="type.toString()"
                                    persistent-hint
                                    label="Document Type">
                      <template v-slot:selection="{ index, item }">
                        <span v-if="index < 1"
                                dark
                                label
                                small>
                          {{ item }}
                        </span>

                        <span v-else-if="index === 1"
                              class="overline grey--text text--darken-3 mx-2">
                          +{{ type.length - 1 }}
                        </span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col xl="3" lg="3" md="6" sm="6" cols="6">
                    <v-autocomplete v-model="status"
                                    :items="statusList"
                                    outlined
                                    flat
                                    multiple
                                    clearable
                                    :hint ="status.toString()"
                                    persistent-hint
                                    label="Task Status">
                      <template v-slot:selection="{ index, item }">
                        <span v-if="index < 1"
                                dark
                                label
                                small>
                          {{ item }}
                        </span>

                        <span v-else-if="index === 1"
                              class="overline grey--text text--darken-3 mx-2">
                          +{{ status.length - 1 }}
                        </span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col xl="3" lg="3" md="6" sm="6" cols="6">
                    <v-autocomplete v-model="user"
                                    :items="userList"
                                    outlined
                                    flat
                                    multiple
                                    clearable
                                    :hint ="user.toString()"
                                    persistent-hint
                                    label="Uploaded By">
                      <template v-slot:selection="{ index, item }">
                        <span v-if="index < 1 && item.length < 10"
                                dark
                                label
                                small>
                          {{ item }}
                        </span>
                        <span v-if="index < 1 && item.length > 10"
                                dark
                                label
                                small>
                          {{substring(item)}}...
                        </span>

                        <span v-else-if="index === 1"
                              class="overline grey--text text--darken-3 mx-2">
                          +{{ user.length - 1 }}
                        </span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                   </v-row>
                </v-col>
                <v-col xl="1" lg="1" md="1" sm="12"  cols="12" >
                  <div >
                    <v-btn class="clear-button"
                           outlined
                           dark
                           color="error"
                           @click="clearAll"
                           height="36"
                           width="100%">
                      Clear
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

      </v-container>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-data-table :headers="headers"
                        :items="files"
                        :options.sync="options"
                        :server-items-length="totalFiles"
                        :loading="loading"
                        class="elevation-1"
                        :footer-props="footer_props"
                        show-select
                        v-model="selected"
                        item-key="id"
                        disable-sort>
            <template v-slot:item.woTaskNumber="{item}">
              <v-btn text small color="primary" @click="goToTask(item.taskId)"> {{item.woTaskNumber}}</v-btn>
              </template>
            <template v-slot:item.action="{ item }">
              <v-icon color="accent"
                      @click="downloadFile(item)">visibility</v-icon>
              <v-icon color="error"
                      @click="deleteDialog(item)">
                mdi-trash-can-outline
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <template>
        <v-row justify="center">
          <v-dialog v-model="deleteConfirmDialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline pt-1 pr-1">
                Confirm Deletion
                <v-spacer></v-spacer>
                <v-btn icon @click="deleteConfirmDialog = false"><v-icon>close</v-icon></v-btn>
              </v-card-title>
              <v-card-text class="pb-1"> Are you sure you want to delete this file?</v-card-text>
              <v-alert v-if="this.error !=null" color="error" dark><v-icon size="20" dark>warning</v-icon>{{this.error}}</v-alert>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn outlined color="error" @click="deleteFile(file)">Delete</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'listDocuments',
    created() {
    // if they are a forman, ensure they only have document & image category options
    if (this.userRole === 'Foreman') {
      this.categoryList = this.foremanCategory
    }
    this.loadAllDocumentTypes()
    this.loadAllUsers()
    this.loadUsersArchived()
    this.getDataFromApi()
  },
  watch: {
    options: {
      handler () {
        this.getDataFromApi()
      },
      deep: true
    },
    category: {
      handler () {
        this.getDataFromApi()
      }
    },
    general: {
      handler () {
        this.getDataFromApi()
      }
    },
    type: {
      handler () {
        this.getDataFromApi()
      }
    },
    status: {
      handler () {
        this.getDataFromApi()
      }
    },
    user: {
      handler () {
        this.getDataFromApi()
      }
    }
  },
  data () {
    return {
      searchEmpty: false,
      archived: false,
      error: null,
      filterPanel: 0,
      disabled: true,
      search: {},
      file: {},
      deleteConfirmDialog: false,
      loading: true,
      downloading: false,
      options: { itemsPerPage: 10, page: 1 },
      general: '',
      type: [],
      category: [],
      user: [],
      status: [],
      selected: [],
      dataObject: {},
      categoryList: ['Change Request', 'Document', 'Image'],
      statusList: ['Initiation', 'Planning', 'Execution', 'FieldComplete','CloseOut'],
      footer_props: {
        'items-per-page-options': [5, 10, 15, 20],
        'showFirstLastPage': true,
        'firstIcon': 'mdi-page-first',
        'lastIcon': 'mdi-page-last'
      },
      singleSelect: true,
      foremanCategory: ['Document', 'Image']
    }
  },
  methods: {
    ...mapActions({
      getTask: 'workOrderTask/getTask',
      loadAllDocumentTypes: 'documentType/loadAllDocumentTypes',
      loadFiles: 'file/getFiles',
      loadAllUsers: 'user/loadAllUsers',
      zip: 'file/getZip',
      reset: 'file/reset',
      getDocURL: 'document/getDocLink',
      getImageURL: 'image/getImageLink',
      getChangeURL: 'changeOrderDocument/getFile',
      deleteDoc: 'document/deleteDocument',
      deleteImage: 'image/deleteImage',
      deleteChange: 'changeOrderDocument/delete',
      loadUsersArchived: 'user/loadArchivedUsers'
    }),
    goToTask (woId) {
      this.getTask(woId)
      this.$router.push('/work-orders')
    },
    substring (string) {
      var short = string.slice(0, 10) + '....'
      return short
    },
    searchIsNotEmpty () {
      if (this.general === null) {
        this.general = ''
      }
      if (this.general.length > 0 || this.type.length > 0 || this.category.length > 0 || this.user.length > 0 || this.status.length > 0) {
        this.searchEmpty = true
      } else {
        this.searchEmpty = false
      }
    },
    async getDataFromApi () {
      this.searchIsNotEmpty()
      this.loading = true
      const { page, itemsPerPage } = this.options

      this.dataObject.page = page
      this.dataObject.archived = false
      this.dataObject.itemsPerPage = itemsPerPage
      let search = {}
      search.type = this.type
      search.category = this.category
      search.general = this.general
      search.uploadedBy = this.user
      search.taskStatus = this.status

      // If they are a foreman and havent selected any categories, ensure they only get documents & images
      if (this.userRole === 'Foreman' && this.category.length === 0) {
        search.category = this.foremanCategory
      }

      this.dataObject.search = search

      await this.loadFiles(this.dataObject)
      this.loading = false
    },
    async downloadFile (file) {
      const submit = { id: file.fileId, fileName: file.fileName }
      switch (file.category) {
        case 'Document':
          await this.getDocURL(submit)
          break
        case 'Image':
          await this.getImageURL(file.fileId)
          break
        case 'Change Request':
          await this.getChangeURL(submit)
          break
        default:
          break
      }
    },
    deleteDialog (file) {
      this.error = null
      this.deleteConfirmDialog = true
      this.file = file
    },
    async deleteFile (file) {
      switch (file.category) {
        case 'Document':
          await this.deleteDoc(file.fileId)
          this.error = this.errorDocument
          break
        case 'Image':
          await this.deleteImage(file.fileId)
          this.error = this.errorImage
          break
        case 'Change Request':
          await this.deleteChange(file.fileId)
          this.error = this.errorChange
          break
        default:
          break
      }
      await this.getDataFromApi()
      if (this.error == null) {
        this.deleteConfirmDialog = false
      }
    },
    async downloadZip () {
      this.downloading = true
      var date = new Date()
      date = date.toLocaleDateString()
      let data = {
        fileName: date + '_download.zip',
        docIds: [],
        imageIds: [],
        changeIds: []
      }

      this.selected.forEach(file => {
        switch (file.category) {
          case 'Document':
            data.docIds.push(file.fileId)
            break
          case 'Image':
            data.imageIds.push(file.fileId)
            break
          case 'Change Request':
            data.changeIds.push(file.fileId)
            break
          default:
            break
        }
      })

      await this.zip(data)
      this.downloading = false
    },
    clearAll () {
      this.general = ''
      this.type = []
      this.category = []
      this.user = []
      this.status = []
    }
  },
  computed: {
    ...mapGetters({
      documentTypes: 'documentType/types',
      files: 'file/files',
      totalFiles: 'file/total',
      headers: 'file/headers',
      allUsers: 'user/users',
      archivedUsers: 'user/archivedUsers',
      errorDocument: 'document/errorDocument',
      errorImage: 'image/error',
      errorChange: 'changeOrderDocument/error',
      userRole: 'user/role'
    }),
    typeList () {
      let typeList = []

      //  Change Request Statuses
      typeList.push('Submitted')
      typeList.push('Pending')

      //  Document Type Names
      this.documentTypes.forEach(x => {
        typeList.push(x.name)
      })

      return typeList
    },
    userList () {
      let userList = []

      this.allUsers.forEach(x => {
        userList.push(x.user.firstName + ' ' + x.user.lastName)
      })

      this.archivedUsers.forEach(x => {
        userList.push(x.user.firstName + ' ' + x.user.lastName)
      })

      return userList
    }
  }
}
</script>
<style>
  .title-wrapper {
    width: 182px;
    height: 36px;
    float: left;
  }

    .header-wrapper {
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0 4px 2px -2px #e7e7e9;
    padding: 12px 12px 12px 12px;
    border-bottom: 1px solid #e1e1e1;
  }

  .filter-wrapper .v-select.v-text-field--outlined:not(.v-text-field--single-line) .v-select__selections {
    padding: 0;
  }
  .filter-wrapper .v-text-field--outlined .v-label {
    font-size: 14px !important;
    top: 8px;
  }
  .filter-wrapper .v-text-field--outlined .v-label--active {
    font-size: 14px !important;
    top: 18px;
  }
  .filter-wrapper .v-text-field.v-text-field--enclosed .v-input__append-inner {
    margin-top: 7px;
  }
</style>
